import React from 'react';
import './card-list.styles.css';
import Card  from '../section.book.card/card.component';

 const CardList = props => (
    <div className='card-list'>
    	{props.books.map(book => (
            <Card key={book.id} book = {book} viewFunc={props.bookToView}/>
        ))}    
    </div>
);
export default CardList;